module.exports = __webpack_public_path__ + "img/logoClaim.ac80ed82.png";